import request from '@/utils/request'

export function getDashboard (data) {
  return request({
    url: '/api/admin/dashboard',
    method: 'post',
    data: data
  })
}
